import { ColDef, ColGroupDef, GridApi, IRowNode, Column } from '@ag-grid-community/core';
import { isNil } from 'lodash';

import * as StyleEditSectionStyles from './StyleEditSection.styles';
import { GranularEditPayloadItem } from 'src/dao/pivotClient';
import { toast } from 'react-toastify';
import serviceContainer from 'src/ServiceContainer';

export function getRowHeight(columnDef: any) {
  switch (columnDef?.renderer) {
    case 'image': {
      return 150;
    }
    case 'validValuesMultiLine':
    case 'validSizes': {
      return StyleEditSectionStyles.validSizesRowHeight;
    }
    case 'color_header': {
      return StyleEditSectionStyles.colorHeaderRowHeight;
    }
    default: {
      return StyleEditSectionStyles.defaultRowHeight;
    }
  }
}

export function setGridRowHeights(columnDefs: (ColDef | ColGroupDef)[], gridApi: GridApi) {
  if (isNil(columnDefs) || isNil(gridApi)) {
    return;
  }

  columnDefs.forEach((colInf: any) => {
    const node = gridApi.getRowNode(colInf.dataIndex);
    if (isNil(node)) {
      return;
    }

    node.setRowHeight(getRowHeight(colInf));
  });

  gridApi.onRowHeightChanged();
}

export async function submitGranular(payload: GranularEditPayloadItem[]) {
  await serviceContainer.pivotService.granularEditSubmitData(payload).catch((e) => {
    toast.error('An error occurred updating data');
  });
}

export function refreshCellsOnly(
  gridApi: GridApi,
  rowNodes: IRowNode[],
  columns: (string | Column)[],
  opts: { forceRefresh?: boolean; suppressFlash?: boolean } = {}
) {
  gridApi.refreshCells({
    rowNodes,
    columns,
    force: opts.forceRefresh ?? false,
    suppressFlash: opts.suppressFlash ?? true,
  });
}
